export default __webpack_public_path__ + "static/media/Group-22.4024666d.png";